import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import { scorePlayoffGame } from '../../../features/game/gameSlice';
import { GameStatus } from '../../../constants/gameConstants';
import AddIcon from '@mui/icons-material/Add';
import ColorLine from '../colorDot/colorLine';

const PlayoffScoreControl = ({ game, team, onScore, submitting = false }) => {
  const dispatch = useDispatch();
  const scoringGame = useSelector((state) => state.game.scoringGame);
  const busy = scoringGame || submitting;

  if (game.status === GameStatus.PLAYOFF && game.playoff?.isDone) {
    return null;
  }

  const handleScoreUpdate = async () => {
    if (onScore) {
      try {
        await onScore({ teamId: team.id, scoreValue: 1 });
      } catch (error) {
        // See ScoreControl: the portal page reports the failure.
      }
      return;
    }

    await dispatch(scorePlayoffGame({ gameId: game.id, teamId: team.id, scoreValue: 1 }));
    //Reload Page
    window.location.reload();
  };

  const increaseScore = () => {
    return (
      <Box
        m={1}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <IconButton
          variant={'contained'}
          color={'background'}
          elevation={2}
          disabled={busy}
          sx={{ width: 50, height: 50, borderRadius: 3, fontWeight: 'bold' }}
          onClick={() => handleScoreUpdate()}>
          <AddIcon />
        </IconButton>
      </Box>
    );
  };

  return (
    <Paper sx={{ mt: 3, maxWidth: '100%', alignSelf: 'center', borderRadius: 2, p: 1 }}>
      <ColorLine color={team.color} />
      <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
        {increaseScore()}
      </Box>
    </Paper>
  );
};

export default PlayoffScoreControl;
